import React from 'react';
import Modal from './Modal';
import FormsySimpleInput from '../form/FormsySimpleInput';
import Select from '../form/Select';
import Formsy from 'formsy-react';
import { allStates } from '../../helpers/selectOptions';

class AddressModal extends React.Component {
  state = {
    address: {
      street_address: '',
      street_address_continued: '',
      city: '',
      state: '',
      zip_code: '',
      label: ''
    }
  };

  render() {
    const { address } = this.state;
    const { isOpen, closeModal, addressIndex } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head">
          <h2 className="h2 modal__heading">
            {addressIndex >= 0 ? 'Edit Address' : 'New Address'}
          </h2>
          <Formsy className="form" onValidSubmit={this.submit}>
            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Address Line 1</p>
                <FormsySimpleInput
                  type="text"
                  name="street_address"
                  placeholder=""
                  value={address.street_address || ''}
                  onChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Address Line 2 (Optional)</p>
                <FormsySimpleInput
                  type="text"
                  name="street_address_continued"
                  placeholder=""
                  value={address.street_address_continued || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="form__row">
              <div className="form__row-item form__row-item--third">
                <p className="simple-input__label">City</p>
                <FormsySimpleInput
                  type="text"
                  name="city"
                  placeholder=""
                  value={address.city || ''}
                  onChange={this.handleChange}
                  required
                />
              </div>
              <div className="form__row-item form__row-item--third">
                <p className="simple-input__label">State</p>
                <Select
                  name="custom_category"
                  value={address.state || ''}
                  options={allStates}
                  onChange={this.handleSelectChange}
                  required
                />
              </div>
              <div className="form__row-item form__row-item--third">
                <p className="simple-input__label">Zip</p>
                <FormsySimpleInput
                  type="text"
                  name="zip_code"
                  placeholder=""
                  value={address.zip_code || ''}
                  onChange={this.handleChange}
                  required
                />
              </div>
            </div>
            <div className="form__row">
              <div className="form__row-item form__row-item--full">
                <p className="simple-input__label">Address Nickname</p>
                <FormsySimpleInput
                  type="text"
                  name="label"
                  placeholder=""
                  value={address.label || ''}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value="Save"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  submit = () => {
    this.props.updateAddress(this.props.addressIndex, this.state.address);
  };

  handleSelectChange = opt => {
    const address = {
      ...this.state.address,
      state: opt ? opt.value : ''
    };
    this.setState({ address });
  };

  handleChange = e => {
    const { name, value } = e.target;
    const address = {
      ...this.state.address,
      [name]: value
    };
    this.setState({ address });
  };

  deriveState() {
    return {
      address: { ...this.props.address }
    };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.address !== prevProps.address) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default AddressModal;



// WEBPACK FOOTER //
// ./src/components/shared/AddressModal.js